import React from "react";
import { Route, Routes } from "react-router-dom";
import TemporaryImageUpload from "./TemporaryImageUpload";

export const PublicDemoRoutes = () => {
  return (
    <Routes>
      <Route path="temp-image-upload" element={<TemporaryImageUpload />} />
    </Routes>
  );
};
